import React, { useState } from 'react';

import { useTranslation } from 'react-i18next';
import ReactModal from 'react-modal';

import Switch from 'shared/components/inputs/Switch/Switch';
import { UserType } from 'api/types';
import { useTheme } from 'styled-components';
import { modalStyles } from 'shared/components/Modal/Modal.styles';

import { Name } from '../AccountBody/AccountBody.styles';
import { ContactInfoBodyHeader, ContentBody } from '../ContactInfoBody/ContactInfoBody.styles';

import { SmsOptInModal } from './SmsOptInModal/SmsOptInModal';
import { SmsOptInPolicySubText } from './SmsOptInModal/Shared/SubText/SmsOptInPolicySubText';
import Body from './SmsOptIn.styles';
import { BodyText } from './SmsOptInModal/Shared/styles';
import ModalBodyType from './SmsOptInModal/types';

type Props = {
  user: UserType | undefined | null;
  updateUserSettings: (variables: { user_id: string; body: { sms_opt_in: boolean } }) => void;
  smsModalType_StorybookOnly?: ModalBodyType;
};
export function SmsOptInBody({ user, updateUserSettings, smsModalType_StorybookOnly }: Props) {
  const { t } = useTranslation();

  const theme = useTheme();

  const [optInModalOpen, setOptInModalOpen] = useState(smsModalType_StorybookOnly !== undefined);

  const SmsOptInStyles = {
    ...modalStyles(theme),
    content: {
      ...modalStyles(theme).content,
      justifyContent: 'center',
    },
    overlay: { ...modalStyles(theme).overlay, zIndex: '1001' },
  };

  const handleCloseOptInModal = () => {
    setOptInModalOpen(false);
  };
  const handleSwitchClick = () => {
    // For phones that are already verified let them toggle their opt-in without legal modal
    if (user && user.phone.verified) {
      updateUserSettings({
        user_id: user.id,
        body: { sms_opt_in: !user.settings.sms_opt_in },
      });
    } else {
      setOptInModalOpen(true);
    }
  };
  return (
    <>
      <ContentBody>
        <ContactInfoBodyHeader>
          <Name as="h3">{t('account.smsOptIn.smsOptIn')}</Name>
        </ContactInfoBodyHeader>
        <Body>
          <BodyText as="p">{t('account.smsOptIn.optInToReceive')}</BodyText>
          <Switch
            label={t('account.smsOptIn.smsOptIn')}
            checked={Boolean(user?.settings.sms_opt_in)}
            onSwitch={handleSwitchClick}
            statusLabel
          />
          <SmsOptInPolicySubText />
        </Body>
      </ContentBody>
      <ReactModal
        isOpen={optInModalOpen}
        appElement={document.querySelector('#root') as HTMLElement}
        style={SmsOptInStyles}
      >
        <SmsOptInModal
          handleCloseModal={handleCloseOptInModal}
          smsModalType_StorybookOnly={smsModalType_StorybookOnly}
          updateUserSettings={updateUserSettings}
        />
      </ReactModal>
    </>
  );
}

export default SmsOptInBody;
